import { Routes } from 'constants/global'
import { TabProps } from 'prace-common-components'

export const initTabs: TabProps[] = [
  { label: 'Dashboard', route: Routes.HOME },
  { label: 'Calls', route: Routes.CALLS },
  { label: 'Submissions', route: Routes.APPLICATIONS },
  { label: 'Users', route: Routes.USER_TABLE },
  { label: 'Partitions', route: Routes.PARTITION_MANAGER },
  { label: 'Templates', route: Routes.TEMPLATE_MANAGER },
  { label: 'Legacy', route: Routes.LEGACY },
]

export const gobackConfig = [
  {
    path: Routes.CALL(':id'),
    label: 'Back to Calls',
  },
]

